<template>
  <div class="container-fluid">
    <b-navbar :is-active.sync="isActive" class="is-spaced co-main-nav">
      <template slot="brand">
        <router-link class="logo" to="/">
          <img src="../assets/img/Corning_GLASS_BoxLockup_Logo.svg" />
        </router-link>
        <h1 class="headline">{{ $t('navbar.headline') }}</h1>
      </template>

      <template slot="end">
        <router-link
          class="navbar-item"
          v-for="(project, index) in projects"
          :key="project.id"
          :to="{ name: project.fields.contentType, params: { id: index } }"
          >{{ project.fields.navTitle }}</router-link
        >
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NavBar',
  data() {
    return {
      isActive: false,
      loading: true
    }
  },
  created() {
    this.fetchProjects()
  },
  methods: {
    async fetchProjects() {
      if (this.$router.history.current.name == 'pdf') return
      if (this.$router.history.current.name == null) return

      this.$store.commit(
        'projects/SET_CONTENT_TYPE',
        this.$router.history.current.name
      )

      if (this.contentType == 'home') return

      if (this.contentType != '') {
        await this.$store.dispatch('projects/fetchProjects', this.contentType)
        try {
          this.loading = false
        } catch (error) {
          console.log('error', error)
        }
      }
    }
  },
  computed: {
    ...mapState('projects', ['projects', 'contentType']),
    ...mapState('mainnav', ['hidden'])
  },
  watch: {
    hidden() {
      if (this.hidden) {
        document
          .getElementsByClassName('co-main-nav')[0]
          .classList.remove('active')
      } else {
        setTimeout(() => {
          document
            .getElementsByClassName('co-main-nav')[0]
            .classList.add('active')
        }, 300)
        document.getElementsByClassName('headline')[0].classList.add('hide')
      }
    },
    contentType() {
      this.fetchProjects()
    },
    $route() {
      this.isActive = false
    }
  }
}
</script>

<style lang="scss" scoped></style>
